<!-- Brand Logo -->
<a [routerLink]="['/dash']" class="brand-link">
    <pf-image
        src="../../../../assets/img/logo-agrama.png"
        alt="AdminLTE Logo"
        class="brand-image shadow-0"
        height="30"
        width="28"
        rounded="true"
        style="opacity: 0.8"
    ></pf-image>
    <span class="brand-text">Agaram Selvi Academy</span>
</a>

<!-- Sidebar -->
<div class="sidebar">
    <!-- Sidebar user (optional) -->

    <!-- <div
        class="user-panel mt-3 pb-2 d-flex"
        style="justify-content: start; align-items: center"
    >
        <pf-image
            src="../../../../assets/img/default-profile.png"
            fallbackSrc="assets/img/default-profile.png"
            style="margin-left: 12px"
            alt="User Image"
            width="34"
            height="34"
            rounded="true"
        />
        <div class="info">
            <a [routerLink]="['/profile']" class="d-block">
                {{ user.email }}
            </a>
        </div>
    </div> -->

    <div class="form-inline">
        <app-sidebar-search></app-sidebar-search>
    </div>

    <!-- Sidebar Menu -->
    <nav class="mt-2">
        <ul
            class="nav nav-pills nav-sidebar flex-column"
            data-widget="treeview"
            role="menu"
            data-accordion="false"
        >
            <app-menu-item *ngFor="let item of menuItems" [menuItem]="item" />
        </ul>
    </nav>
</div>
